import React, { useEffect, useRef, useState } from "react";
import "./May_you_like_also.css";
import Product_card from "../../common-components/product_card/Product_card";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import Order_summery_holder from "./order_summery_holder/Order_summery_holder";
import { Navigation } from "swiper/modules";
import { useDispatch, useSelector } from "react-redux";
import { getAllProducts } from "../../../features/products/productsSlice";

import Product_Info_Card from "../../common-components/product_info_card/Product_Info_Card";
import { variant_type } from "../../../utils/common";

function May_you_like_also({ data, instock }) {
  const dispatch = useDispatch();
  const productdata = useSelector((state) => state.product.allProducts);

  // const products = productdata?.data || [];
   const products = data || [];


  useEffect(() => {
    dispatch(
      getAllProducts({
        // name: searchTerm,
      }),
    );
  }, [dispatch]);

  return (
    <section className="May_you_like_also">
      <div className="container-fluid">
        <div className="row custom_row">
          <div className="col-md-12">
            <div className="heading_holder">
              <h4 className="heading_text">YOU MAY ALSO LIKE</h4>
            </div>
            <Swiper
              modules={[Pagination, Navigation]}
              navigation={true}
              spaceBetween={16}
              slidesPerView={2}
              pagination={{ clickable: true }}
              breakpoints={{
                576: { slidesPerView: 2 },
                768: { slidesPerView: 1.5 },
                992: { slidesPerView: 1.9 },
                1200: { slidesPerView: 5 },
              }}
            >
              {/* {productdata?.data?.map((product, index) => ( */}
              {products?.length > 0 ? (
                products?.map((product, index) => {
                  let plating;
                  let colour;
                  let size;

                  if (
                    Number(product?.variant_type_id) ===
                    Number(variant_type.Single)
                  ) {
                    plating = product?.Product_Variants?.[0];
                  } else if (
                    Number(product?.variant_type_id) ===
                    Number(variant_type.Double)
                  ) {
                    plating = product?.Product_Variants?.[0];
                    colour = plating?.Double_Variants?.[0];
                  } else if (
                    Number(product?.variant_type_id) ===
                    Number(variant_type.Triple)
                  ) {
                    plating = product?.Product_Variants?.[0];
                    colour = plating?.Double_Variants?.[0];
                    size = colour?.Triple_Variants?.[0];
                  }

                  const activeVariant = size || colour || plating;

                  return (
                    <SwiperSlide key={index}>
                      <Product_Info_Card
                        product={product}
                        id={product?.id}
                        imgSrc={product?.image}
                        vdoSrc={product?.image}
                        productName={product?.name}
                        prodDiscount={product?.prod_discount}
                        productDesignId={product?.design_id}
                        priceText={product?.Product_Variants?.[0].price || 0}
                        mrp={product?.Product_Variants?.[0].mrp || 0}
                        savingPrice={
                          parseFloat(product?.Product_Variants?.[0].mrp || 0) -
                          parseFloat(product?.Product_Variants?.[0].price || 0)
                        }
                      />
                    </SwiperSlide>
                  );
                })
              ) : (
                <div
                  style={{
                    textAlign: "center",
                    padding: "20px",
                    fontWeight: "bold",
                    width: "100%",
                    color: "white",
                  }}
                >
                  Product Not Available
                </div>
              )}
              {/* ))} */}
            </Swiper>
          </div>
          
        </div>
      </div>
    </section>
  );
}

export default May_you_like_also;
